// extracted by mini-css-extract-plugin
export var completionBody = "_gz-2";
export var completionCard = "_gz-0";
export var completionFooter = "_gz-3";
export var completionTitle = "_gz-1";